/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2026-05-08 17:33:18
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-05-14 15:41:38
 * @FilePath: /designcenter/src/store/locale.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia'
import { getLanguageCode, isValidSite, DEFAULT_SITE } from '@/constant/siteMapping'
import { useLangLoader } from '@fs-front/lang-loader/vue'
import { persistSite, resolveInitialSite } from '@/utils/modules/site'

let translationRequestId = 0

export interface LocaleState {
  currentSite: string
  currentLocale: string
  langPacks: Record<string, Record<string, string>>
  isLoading: boolean
  /** 语言包版本号，每次翻译更新时递增，用于触发组件响应式更新 */
  langVersion: number
  /** 站点切换版本号，用于通知依赖站点信息的业务数据静默刷新 */
  siteChangeVersion: number
  /** 已加载的翻译模块列表，切换站点时用于重新加载 */
  loadedModules: string[]
}

export const useLocaleStore = defineStore('locale', {
  state: (): LocaleState => ({
    currentSite: DEFAULT_SITE,
    currentLocale: getLanguageCode(DEFAULT_SITE),
    langPacks: {},
    isLoading: false,
    langVersion: 0,
    siteChangeVersion: 0,
    loadedModules: [],
  }),

  getters: {
    locale: state => state.currentLocale,
  },

  actions: {
    initLocale() {
      const site = resolveInitialSite()
      this.currentSite = site
      this.currentLocale = getLanguageCode(site)
    },

    /**
     * 动态切换站点语言，无需刷新页面
     * 1. 更新响应式站点状态
     * 2. 重新加载所有已加载的翻译模块
     * 3. 递增 langVersion 触发组件响应式更新
     */
    async setLocale(site: string) {
      if (!isValidSite(site)) {
        return
      }

      this.currentSite = site
      this.currentLocale = getLanguageCode(site)

      persistSite(site)

      // 重新加载所有已加载的翻译模块
      if (this.loadedModules.length > 0) {
        await this.loadTranslations(this.loadedModules)
      }
    },

    notifySiteChange() {
      this.siteChangeVersion++
    },

    async loadTranslations(modules: string[]) {
      const requestId = ++translationRequestId
      const requestedSite = this.currentSite
      this.isLoading = true
      // 记录已加载的模块，用于切换站点时重新加载
      this.loadedModules = modules
      try {
        const loader = useLangLoader()
        const result = await loader.load(modules, requestedSite)
        if (requestId !== translationRequestId || requestedSite !== this.currentSite) return

        this.langPacks = result
        // 递增版本号，触发所有使用 useI18n 的组件重新渲染
        this.langVersion++
      } catch (e) {
        console.error('Failed to load translations:', e)
        // Retain previous langPacks data on error
      } finally {
        if (requestId === translationRequestId) {
          this.isLoading = false
        }
      }
    },
  },
})
